import ExpandableGroup from "@/components-library/layout/expandable-group";
import Label from "@/components-library/widgets/label";
import ExpandableContainer from "@/components-library/layout/expandable-container";
import Content from "./content";
import Header from "./header";
import classes from "./slectable-list.module.scss";
import classNames from "classnames";
function SelectableList({
  list,
  selectedItem,
  title,
  isEnabled,
  isMultiSelect,
  onItemSelect,
  onCloseList,
  onHeaderClick,
  isOpen,
  offsetWidth,
  headerClassName,
  titleClassName,
}) {
  return (
    <div>
      <Label
        tag="p"
        size="lg"
        weight="bold"
        align="start"
        className={titleClassName}
      >
        {title}
      </Label>
      <Header
        label={selectedItem}
        onClick={onHeaderClick}
        isOpen={isOpen}
        className={classNames(classes.header, headerClassName)}
      />
      <ExpandableContainer
        className={classes.container}
        isOpen={isOpen}
        style={{ width: offsetWidth }}
        key={title}
      >
        {isEnabled && (
          <ExpandableGroup singleOpen={true}>
            {list &&
              list.map((obj, index) => {
                return (
                  <Content
                    key={obj?.name}
                    name={obj?.name}
                    title={obj?.title}
                    isSelected={obj?.isSelected}
                    isMultiSelect={isMultiSelect}
                    isLast={index === list.length - 1}
                    onCloseList={onCloseList}
                    onItemSelect={onItemSelect}
                  />
                );
              })}
          </ExpandableGroup>
        )}
      </ExpandableContainer>
    </div>
  );
}

export default SelectableList;
